import { Button, Grid, makeStyles, MenuItem, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getBranchList } from "../../actions/commonAction";
import { getUserList } from "../../actions/userManagementActions";
import _ from 'lodash';
import { queryToBeForwardOrders, queryTaskList } from "../../actions/orderExchangeActions";
import { showAlertSnackbar } from "../../reducers/uiSlice";

const useStyles = makeStyles((theme)=> ({
    root: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        borderBottom: '1px solid rgba(81, 81, 81, 1)',
        maxWidth: '100%'
    }
}))

export default function ConditionalSearch(props) {
    const {t} = useTranslation('orderForwardTool');
    const dispatch = useDispatch();
    const classes = useStyles();

    const branches = useSelector(state => state.common.branches);
    const userListAll = useSelector(state => state.userManagementReducer.userListAll);


    const statuses = [
        {
            id: -1,
            text: t('common:all')
        },
        {
            id: 0,
            text: t('pending')
        },
        {
            id: 1,
            text: t('order_placed')
        },
        {
            id: 2,
            text: t('failed_to_forward')
        },
    ]

    const failedToForwardList = [
        {
            id: -1,
            code: 'all',
            text: t('common:all')
        },
        {
            id: 0,
            code: 'CP', 
            text: 'Canada Post'
        },
        {
            id: 1,
            code: 'FD',
            text: 'FedEx'
        },
        {
            id: 2,
            code: 'GV',
            text: 'GV'
        }
    ]


    const [warehouse, setWarehouse] = useState(-1);
    const [dateFrom, setDateFrom] = useState(moment().format('YYYY-MM-DD'));
    const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));
    const [status, setStatus] = useState(-1);
    const [users, setUsers] = useState([]);
    const [createdBy, setCreatedBy] = useState();
    const [failedToForward, setFailedToForward] = useState('all');
    const [trackingNo, setTrackingNo] = useState('');


    const handleSearch = () => {
        props.initSummary();
        if(props.type === 'orders') {
            let params = {
                start_time: moment(dateFrom).startOf('day').valueOf() / 1000,
                end_time: Math.floor(moment(dateTo).endOf('day').valueOf() / 1000),
                warehouse: warehouse,
                transship_status: status === -1 ? null : status,
                transship_carrier: failedToForward === 'all' ? null : failedToForward,
                'tnos[]': trackingNo ? trackingNo : null
            }
            dispatch(queryToBeForwardOrders(params))
            .then((res) => {
                console.log(res)
            })
            .catch((err) => {
                dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
            })
        } else {
            const params = {
                start_time: moment(dateFrom).startOf('day').valueOf() / 1000,
                end_time: Math.floor(moment(dateTo).endOf('day').valueOf() / 1000),
                warehouse: warehouse,
                task_status: status === -1 ? null : status,
                creator: createdBy
            }
            dispatch(queryTaskList(params))
            .catch((err) => {
                dispatch(showAlertSnackbar({message: t('query_fail'), type: 'error'}));
            })
        }
    }


    useEffect(() => {
        if(warehouse === -1) {
            setUsers(userListAll);
        } else {
            const userList = userListAll.filter((user) => {
                const warehouseList = _.toArray(user.warehouse);
                if(warehouseList.includes(warehouse.toString())) {
                    return user;
                }  
            })
            setUsers(userList);
        }
    }, [warehouse])

    useEffect(() => {
        setUsers(userListAll);
    }, [userListAll])

    useEffect(() => {
        if(!branches?.length) {
            dispatch(getBranchList());
        }
        if(!userListAll?.length) {
            dispatch(getUserList());
        }
        setWarehouse(-1);
        setUsers(userListAll);
    }, [])


    return (
        <Grid container spacing={2} className={classes.root}>
            <Grid item xs={2}>
                <TextField 
                    id='orderforwardtool-conditionalsearch-branch-textfield'
                    select
                    label={t('warehouse')}
                    value={warehouse}
                    onChange={(e)=>setWarehouse(e.target.value)}
                    fullWidth
                    variant="outlined"
                >
                    <MenuItem value={'-1'}>{t('common:all')}</MenuItem>
                    {
                        branches?.length > 0 &&
                        branches.map((branch) => (
                            <MenuItem 
                                key={branch.id} 
                                value={branch.id}
                            >
                                {branch.name}
                            </MenuItem>
                        ))
                    }
                </TextField>
            </Grid>
            <Grid item xs={2}>
                <TextField
                    id="orderforwardtool_datefrom_textfield"
                    type="date"
                    variant="outlined"
                    value={dateFrom}
                    onChange={(e)=>setDateFrom(e.target.value)}
                    fullWidth
                    label={t('date_from')}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    id="orderforwardtool-conditionalsearch-dateTo-textfield"
                    type="date"
                    variant="outlined"
                    value={dateTo}
                    onChange={(e)=>setDateTo(e.target.value)}
                    fullWidth
                    label={t('date_to')}
                />
            </Grid>
            {
                props.type === 'batches' &&
                <Grid item xs={3}>
                    <Autocomplete
                        id="orderforwardtool-conditionalsearch-createdby-autocomplete"
                        options={users}
                        getOptionLabel={(option) => option.username}
                        filterSelectedOptions
                        limitTags={1}
                        onInputChange={(event, value) => {
                            setCreatedBy(value)
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label={t('created_by')}
                            />
                        )}
                        value={createdBy}
                    />
                </Grid>
            }
            <Grid item xs={2}>
                <TextField 
                    id='orderforwardtool-conditionalsearch-status-textfield'
                    select
                    label={t('status')}
                    value={status}
                    onChange={(e)=>setStatus(e.target.value)}
                    fullWidth
                    variant="outlined"
                >
                    {
                        statuses.map((status) => (
                            <MenuItem 
                                key={status.id} 
                                value={status.id}
                            >
                                {status.text}
                            </MenuItem>
                        ))
                    }
                </TextField>
            </Grid>
            {
                props.type === 'orders' &&
                <Grid item xs={1}>
                    <TextField 
                        id='orderforwardtool-conditionalsearch-failedtoforward-textfield'
                        select
                        label={t('failed_to_forward')}
                        value={failedToForward}
                        onChange={(e)=>setFailedToForward(e.target.value)}
                        fullWidth
                        variant="outlined"
                    >
                        {
                            failedToForwardList.map((failed) => (
                                <MenuItem 
                                    key={failed.id} 
                                    value={failed.code}
                                >
                                    {failed.text}
                                </MenuItem>
                            ))
                        }
                    </TextField>
                </Grid>
            }
            {
                props.type === 'orders' &&
                <Grid item xs={2}>
                    <TextField 
                        id='orderforwardtool-conditionalsearch-trackingno-textfield'
                        label={t('tracking_no')}
                        value={trackingNo}
                        onChange={(e)=>setTrackingNo(e.target.value)}
                        fullWidth
                        variant="outlined"
                    />
                </Grid>
            }
            <Grid item xs={1}>
                <Button 
                    id='orderforwardtool-conditionalsearch-search-button'
                    variant="contained" 
                    color="primary"
                    onClick={handleSearch}
                >
                    {t('common:search')}
                </Button>
            </Grid>
        </Grid>
    )
}